import { ColumnDef, OperationRow } from './types';

export const COLUMNS: ColumnDef<OperationRow>[] = [
  {
    id: 'stage',
    label: 'Operation',
    accessor: (r) => r.stage,
    sortValue: (r) => r.stage,
    totalType: 'unique',
    category: 'basic',
    dataType: 'enum',
  },
  {
    id: 'workOrderId',
    label: 'Work Order',
    accessor: (r) => r.workOrderId,
    sortValue: (r) => r.workOrderId,
    totalType: 'count',
    category: 'basic',
    dataType: 'string',
  },
  {
    id: 'orderNumber',
    label: 'Sales Order',
    accessor: (r) => r.orderNumber,
    sortValue: (r) => r.orderNumber,
    totalType: 'unique',
    category: 'basic',
    dataType: 'string',
  },
  {
    id: 'customer',
    label: 'Customer',
    accessor: (r) => r.customer,
    sortValue: (r) => r.customer,
    totalType: 'unique',
    category: 'basic',
    dataType: 'enum',
  },
  {
    id: 'fabricType',
    label: 'Fabric',
    accessor: (r) => r.fabricType,
    sortValue: (r) => r.fabricType,
    totalType: 'unique',
    category: 'basic',
    dataType: 'enum',
  },
  {
    id: 'frameColor',
    label: 'Frame Color',
    accessor: (r) => r.frameColor,
    sortValue: (r) => r.frameColor,
    totalType: 'unique',
    category: 'basic',
    dataType: 'enum',
  },
  {
    id: 'status',
    label: 'Status',
    accessor: (r) => r.status,
    sortValue: (r) => r.status,
    totalType: 'count',
    category: 'basic',
    dataType: 'enum',
  },
  {
    id: 'predecessors',
    label: 'Predecessors',
    accessor: (r) => r.predecessors,
    sortValue: (r) => r.predecessors,
    totalType: 'count',
    category: 'basic',
    dataType: 'enum',
  },
  {
    id: 'location',
    label: 'Location',
    accessor: (r) => r.location,
    sortValue: (r) => r.location,
    totalType: 'unique',
    category: 'basic',
    dataType: 'enum',
  },
  {
    id: 'date',
    label: 'Date',
    accessor: (r) => r.date,
    sortValue: (r) => r.dateTs,
    totalType: 'count',
    category: 'basic',
    dataType: 'date',
    numericValue: (r) => r.dateTs,
  },
];
